import { ChangeDetectionStrategy, Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Application } from '@splinetool/runtime';

@Component({
  selector: 'csn-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingComponent implements AfterViewInit {

  @ViewChild('canvas') canvas?: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    this.embedSplineAnimation();
  }

  embedSplineAnimation() {
    if (this.canvas) {
      const app = new Application(this.canvas.nativeElement);
      app.load('https://prod.spline.design/C4876MEOMAnKqBDx/scene.splinecode');
    }
  }
  
}
